import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Skeleton — placeholder shimmer with 1.8s low-contrast sweep.
 *
 * Use whenever the eventual layout shape is known (lists, tables,
 * cards). Spinners are reserved for actions under 500ms where the
 * layout isn't yet known; determinate progress bars for any
 * percentage-bearing wait.
 *
 * Respects ``prefers-reduced-motion``: shimmer freezes at midpoint
 * via the motion-safe utility so the placeholder is still visible.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn(
        "rounded-md bg-surface-2",
        "motion-safe:animate-shimmer motion-safe:bg-gradient-to-r motion-safe:from-surface-2 motion-safe:via-surface-3 motion-safe:to-surface-2 motion-safe:bg-[length:200%_100%]",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
